import Config from "src/Constants/Config";

import setCurrentPage from "src/Utils/setCurrentPage";

import { Audios, Animation } from "@yamildiego/presentation-kit";

import store from "src/Reducers/store";
import { useSelector } from "react-redux";

const PageId = 226;
const PreviousPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA_JOURNEY_ONE = () => {
  const path = "/images/balance_rollover/phone_26/phone_";
  const DATA_IMAGES = [
    { image: `${Config.BASE_URL}${path}0.png`, effect: "animate-opacity", imageStyle: { width: "72.375rem", right: 0, top: 0 } },
    { image: `${Config.BASE_URL}${path}1.png`, effect: "animate-opacity", imageStyle: { width: "72.375rem", right: 0, top: 0 } },
    { image: `${Config.BASE_URL}${path}2.png`, effect: "animate-opacity", imageStyle: { width: "72.375rem", right: 0, top: 0 } },
    { image: `${Config.BASE_URL}${path}3.png`, effect: "animate-opacity", imageStyle: { width: "72.375rem", right: 0, top: 0 } },
    { image: `${Config.BASE_URL}${path}4.png`, effect: "animate-opacity", imageStyle: { width: "72.375rem", right: 0, top: 0 } },
  ];

  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const muted = useSelector(() => store.getState().appReducer.muted);
  const audioSrc = `${Config.BASE_URL}/audios/balance_rollover/PRCX_18_Balance - ${PageId}.mp3`;

  return {
    bgImage: `${Config.BASE_URL}/images/balance_rollover/bg_03.png`,
    labels: [
      {
        icon: `${Config.BASE_URL}/images/icons/clock.png`,
        text: "6:00 PM",
      },
      {
        icon: `${Config.BASE_URL}/images/icons/location.png`,
        text: "James' home",
      },
      {
        icon: `${Config.BASE_URL}/images/icons/oration.png`,
        text: "Oration",
        style: { backgroundColor: "#c3834e" },
      },
    ],
    text: "James gives PCXSuper a call and\nanswers a few questions about his\npersonal details.",
    back: { label: "Go Back", type: "back", startIcon: "arrow-left", onClick: () => setCurrentPage(PreviousPageId) },
    next: { label: "Continue", type: "next", endIcon: "arrow-right", onClick: () => setCurrentPage(NextPageId) },
    rightSideComponent: <Animation pageNumber={PageId} currentPage={currentPage} images={DATA_IMAGES} />,
    audio: <Audios muted={muted} pageNumber={PageId} currentPage={currentPage} audios={[{ src: audioSrc, timer: 0 }]} />,
  };
};

export default DATA_JOURNEY_ONE;
